module.exports = __webpack_public_path__ + "img/chengdefut.f9b40691.jpg";